<template>
  <div class="add--resource--root">
    <h2 class="ui header">
      Add New Event
    </h2>

    <form class="ui form add--resource--form">
      <sui-tab>
        <sui-tab-pane icon="pencil alternate" title="Event Info">
          <h3>Event Info</h3>
          <div class="field" :class="{ error: errors.title }">
            <label>Title</label>
            <input type="text" v-model="resource.title" placeholder="Resource Title" required>
            <div class="ui red pointing label" v-if="errors.title">{{ errors.title }}</div>
          </div>
          <div class="field">
            <div class="field two fields">
              <div class="field">
                <label>Logo</label>
                <input type="file" ref="fileInput" placeholder="Event Logo" v-on:change="uploadTheLogo" accept="image/*">
                <p>{{ msg }}</p>
                <img :src="previewImage" v-if="previewImage" style="height: 100px;">
              </div>
              <div class="field">
                <label>Featured Image / banner</label>
                <input type="file" ref="fileInput" placeholder="Featured Image" v-on:change="uploadTheFeaturedImage"
                  accept="image/*">
                <p>{{ msg2 }}</p>
                <img :src="previewFeaturedImage" v-if="previewFeaturedImage" style="height: 100px;">
              </div>
            </div>
          </div>
          <div class="field">
            <div class="field two fields">
              <div class="field">
                <label>Start Date</label>
                <input type="date" v-model="resource.start_date" placeholder="Start Date" required>
              </div>
              <div class="field">
                <label>End Date</label>
                <input type="date" v-model="resource.end_date" placeholder="End Date" required>
              </div>
            </div>
          </div>
          <div class="field">
            <div class="field two fields">
              <div class="field">
                <label>Start Time</label>
                <input type="time" v-model="resource.start_time" placeholder="Start Time" required>
              </div>
              <div class="field">
                <label>End Time</label>
                <input type="time" v-model="resource.end_time" placeholder="End Time" required>
              </div>
            </div>
          </div>
          <div class="field">
            <label>Description</label>
            <editor ref="tuiEditor" :options="editorOptions" height="500px" initialEditType="wysiwyg"
              previewStyle="vertical" @change="handleEditorChange" />
          </div>
          <div class="field two fields">
            <div class="field" :class="{ error: errors.locations }">
              <label>Location</label>
              <sui-dropdown fluid multiple :max-selections="5" :options="locations" placeholder="Locations" selection
                v-model="resource.locations" :class="{ error: errors.locations }" />
            </div>
            <div class="field" :class="{ error: errors.organizers }">
              <label>Organizer</label>
              <sui-dropdown fluid :options="organizers" placeholder="Organizers" multiple :max-selections="1" selection
                v-model="resource.organizers" :class="{ error: errors.organizers }" />
              <div class="ui red pointing label" v-if="errors.organizers">{{ errors.organizers }}</div>
            </div>
          </div>
          <div class="field" :class="{ error: errors.categories }">
            <label>Categories</label>
            <sui-dropdown fluid multiple :max-selections="5" :options="categories" placeholder="Categories" selection
              v-model="resource.categories" :class="{ error: errors.categories }" />
          </div>


        </sui-tab-pane>
        <sui-tab-pane icon="user outline" title="Speakers">
          <h3>Speakers</h3>

          <div class="field speaker--form" v-for="(speaker, i) in resource.speakers" :key="i">
            <!-- remove speaker -->
            <button class="ui icon button item--removal" type="button" @click="resource.speakers.splice(i, 1)">
              <i class="close icon"></i>
            </button>
            <h4 class="ui horizontal divider header">
              <i class="user outline icon"></i>
              Speaker # {{ i +1 }}
            </h4>
            <div class="field three fields">
              <div class="field">
                <label>Name</label>
                <input type="text" v-model="resource.speakers[i].speaker.speaker_info.name" placeholder="Name" required>
              </div>
              <div class="field">
                <label>Job Title</label>
                <input type="text" v-model="resource.speakers[i].speaker.speaker_info.job_title" placeholder="Job Title" required>
              </div>
              <div class="field">
                <label>Image</label>
                <input type="file" ref="fileInput" placeholder="Speaker Image" v-on:change="speakersImagesUpload($event, i)"
                 accept="image/*"> 
                <p>{{ resource.speakers[i].speaker.speaker_info.msg }}</p>
                <img :src="resource.speakers[i].speaker.speaker_info.imagePreview" v-if="resource.speakers[i].speaker.speaker_info.imagePreview"
                 style="height: 100px;">
              </div>
            </div>
            <!-- social_profiles check field -->
            <div class="field">
              <div class="ui checkbox">
                <input type="checkbox" v-model="resource.speakers[i].speaker.social.social_profiles" :id="`social_profiles_${i}`">
                <label :for="`social_profiles_${i}`">Social Profiles</label>
              </div>
            </div>
            <!-- check for social_profiles -->
            <div class="field" v-if="resource.speakers[i].speaker.social.social_profiles">
              <div class="field three fields">
                <div class="field">
                  <label>Facebook</label>
                  <input type="text" v-model="resource.speakers[i].speaker.social.facebook_url" placeholder="Facebook URL" required>
                </div>
                <div class="field">
                  <label>Twitter</label>
                  <input type="text" v-model="resource.speakers[i].speaker.social.twitter_url" placeholder="Twitter URL" required>
                </div>
                <div class="field">
                  <label>LinkedIn</label>
                  <input type="text" v-model="resource.speakers[i].speaker.social.linkedin_url" placeholder="LinkedIn URL" required>
                </div>
              </div>
            </div>
          </div>


          <button class="ui button sc--btn" type="button" @click="resource.speakers.push({speaker: {speaker_info: {name: '', job_title: '', image: '', imagePreview: '', msg: ''}, social: {social_profiles: false, facebook_url: '', twitter_url: '', linkedin_url: ''}}})">Add Speaker</button>

        </sui-tab-pane>
        <sui-tab-pane icon="calendar alternate outline" title="Agenda">
          <h3>Event Agenda</h3>
          
          <div class="day--form" v-for="(day, i) in resource.agendas" :key="i">
            <button class="ui icon button item--removal" type="button" @click="resource.agendas.splice(i, 1)">
              <i class="close icon"></i>
            </button>
            <h4 class="ui horizontal divider header">
              <i class="calendar icon"></i>
              Day # {{ i +1 }}
            </h4>
            <div class="field two fields">
              <div class="field">
                <label>Date</label>
                <input type="date" v-model="resource.agendas[i].day.date" placeholder="Date" required>
              </div>
              <div class="field">
                <label>Day Title</label>
                <input type="text" v-model="resource.agendas[i].day.day_title" placeholder="Day Title" required>
              </div>
            </div>
            <div class="field agenda--form" v-for="(agenda, j) in resource.agendas[i].day.agenda" :key="j">
              <button class="ui icon button item--removal" type="button" @click="resource.agendas[i].day.agenda.splice(i, 1)">
              <i class="close icon"></i>
              </button>
              <div class="ui tag purple label">Agenda #{{ j +1 }}</div>
              <br>
              <div class="field two fields">
                <div class="field">
                  <label>Title</label>
                  <input type="text" v-model="resource.agendas[i].day.agenda[j].title" placeholder="Title" required>
                </div>
                <div class="field">
                  <label>Description</label>
                  <textarea v-model="resource.agendas[i].day.agenda[j].description" placeholder="Description" required></textarea>
                </div>
              </div>
              <div class="field two fields">
                <div class="field">
                  <label>Start Time</label>
                  <input type="time" v-model="resource.agendas[i].day.agenda[j].time_range.start_at" placeholder="Start Time" required>
                </div>
                <div class="field">
                  <label>End Time</label>
                  <input type="time" v-model="resource.agendas[i].day.agenda[j].time_range.end_at" placeholder="End Time" required>
                </div>
              </div>
            </div>
            <button class="ui button sc--btn" type="button" @click="resource.agendas[i].day.agenda.push({title: '', description: '', time_range: {start_at: '', end_at: ''}})">Add Agenda</button>

          </div>
          
          <br>
          <div class="ui section divider"></div>
          <button class="ui button sc--btn" type="button" @click="resource.agendas.push({day: {date: '', day_title: '', agenda: [{title: '', description: '', time_range: {start_at: '', end_at: ''}}]}})">Add Day</button>

        </sui-tab-pane>
      </sui-tab>
      


      <button class="ui button sc--btn" type="submit" @click.prevent="addResource">Submit For Review</button>
    </form>
  </div>
</template>

<script>
import '@toast-ui/editor/dist/toastui-editor.css';
import axios from 'axios';
import { Editor } from '@toast-ui/vue-editor';

export default {
  name: 'AddResource',
  components: {
    editor: Editor
  },
  data() {
    return {
      editorContent: 'hs',
      editorOptions: {
        hideModeSwitch: true,
        usageStatistics: false
      },
      resource: {
        title: '',
        description: '',
        start_date: '',
        end_date: '',
        start_time: '',
        end_time: '',
        locations: [],
        organizers: [],
        categories: [],
        speakers: [
          {
            speaker: {
            speaker_info: {
              name: '',
              job_title: '',
              image: '',
              imagePreview: '',
              msg: ''
            },
            social: {
              social_profiles: false,
              facebook_url: '',
              twitter_url: '',
              linkedin_url: ''
            }
          }
        }
        ],
        agendas: [
          {
            day: {
              date: '',
              day_title: '',
              agenda: [
                {
                  title: '',
                  description: '',
                  time_range: {
                    start_at: '',
                    end_at: ''
                  }
                }
              ]
            }
          }
        ],
        logo: 0,
        featured_image: 0,
      },
      locations: [],
      organizers: [],
      categories: [],
      errors: {
        title: '',
        description: '',
        locations: '',
        organizers: '',
        categories: '',
        speakers: '',
        agenda: '',
        featured_image: '',

      },
      formValidate: false,
      authToken: localStorage.getItem('sjdifjsckdsjfosdf54520bearer'),
      mediaID: 0,
      mediaName: 'unknown',
      previewImage: '',
      previewFeaturedImage: '',
      speakersTemp: [],
      msg: '',
      msg2: '',
    };
  },
  methods: {
    handleEditorChange() {
      // Update the bound data when the editor content changes
      this.resource.description = this.$refs.tuiEditor.invoke('getHTML');
    },
    submitForm() {
      this.formValidate = true;
      if (this.validateForm()) {
        this.formValidate = false;
      }
    },
    validateForm() {
      let valid = true;
      if (!this.resource.title) {
        this.errors.title = 'Title is required';
        valid = false;
      } else {
        this.errors.title = '';
      }
      if (!this.resource.description) {
        this.errors.description = 'Description is required';
        valid = false;
      } else {
        this.errors.description = '';
      }
      if (!this.resource.locations) {
        this.errors.locations = 'Locations is required';
        valid = false;
      } else {
        this.errors.locations = '';
      }
      if (!this.resource.organizers) {
        this.errors.organizers = 'Organizers is required';
        valid = false;
      } else {
        this.errors.organizers = '';
      }
      if (!this.resource.categories) {
        this.errors.categories = 'Categories is required';
        valid = false;
      } else {
        this.errors.categories = '';
      }
      if (!this.resource.speakers) {
        this.errors.speakers = 'Speakers is required';
        valid = false;
      } else {
        this.errors.speakers = '';
      }
      if (!this.resource.agenda) {
        this.errors.agenda = 'Agenda is required';
        valid = false;
      } else {
        this.errors.agenda = '';
      }
      if (!this.resource.featured_image) {
        this.errors.featured_image = 'Featured Image is required';
        valid = false;
      } else {
        this.errors.featured_image = '';
      }

      return valid;
    },
    async addResource() {
      this.validateForm();
      if (this.validateForm) {
        try {
          const requestBody = {
            event_data: this.resource,
            k__sjnb__sdfjn0547: localStorage.getItem('sjdifjsckdsjfosdf54520zzz')
          };
          const response = await fetch('/wp-json/custom/v1/add-event', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${this.authToken}`,
            },
            body: JSON.stringify(requestBody)
          });

          const responseData = await response.json();

          if (response.ok && responseData.success) {
            console.log('Resource added:', responseData.post_id);
            this.$router.push('/dashboard/events');
          } else {
            console.error('Failed to add resource:', responseData);
            // Handle error cases, show error messages, etc.
          }
        } catch (error) {
          console.error('An error occurred:', error);
        }
      }
    },
    getAuthToken() {
      return localStorage.getItem('sjdifjsckdsjfosdf54520yyy');
    },
    getResourseTypes() {
      fetch('/wp-json/wp/v2/location')
        .then(response => response.json())
        .then(data => {
          data.forEach(location => {
            this.locations.push({
              key: location.id,
              text: location.name,
              value: location.slug
            });
          });
        });

      fetch('/wp-json/wp/v2/organizer')
        .then(response => response.json())
        .then(data => {
          data.forEach(organizer => {
            this.organizers.push({
              key: organizer.id,
              text: organizer.name,
              value: organizer.slug
            });
          });
        });

      fetch('/wp-json/wp/v2/categories')
        .then(response => response.json())
        .then(data => {
          data.forEach(category => {
            this.categories.push({
              key: category.id,
              text: category.name,
              value: category.slug
            });
          });
        });
    },
    handleFileChange(event) {
      this.resource.thumbnail = event.target.files[0];
      this.msg = 'Uploading...';
      console.log(this.resource.thumbnail);
      const reader = new FileReader();
      reader.readAsDataURL(this.resource.thumbnail);
      reader.onload = e => {
        this.previewImage = e.target.result;
      };
    },
    uploadTheLogo(event) {
      this.resource.thumbnail = event.target.files[0];
      this.msg = 'Uploading...';
      const wpPostPoint = `/wp-json/wp/v2/media`;
      let theFile = this.resource.thumbnail;

      this.mediaName = theFile.name;

      let axiosConfig = {
        headers: {
          'Authorization': 'Bearer ' + this.authToken,
          'cache-control': 'no-cache',
          'content-disposition': `attachment; filename=${this.mediaName}`,
          'content-type': theFile.type
        }
      }

      let postData = theFile;
      let mediaURL = '';

      axios.post(wpPostPoint, postData, axiosConfig)
        .then(response => {
          mediaURL = response.data.source_url;
          this.mediaID = response.data.id * 1;
          this.resource.logo = this.mediaID;
          console.log('Media ID: ' + this.mediaID);
          console.log('Media URL: ' + mediaURL);
          this.msg = 'Upload Complete';
          this.previewImage = mediaURL;
          setTimeout(() => {
            this.msg = '';
          }, 5000);
        }).catch(function (error) {
          console.log('Error osn post: ' + error);
        });

    },
    uploadTheFeaturedImage(event) {
      this.resource.featured_image = event.target.files[0];
      this.msg2 = 'Uploading...';
      const wpPostPoint = `/wp-json/wp/v2/media`;
      let theFile = this.resource.featured_image;

      this.mediaName = theFile.name;

      let axiosConfig = {
        headers: {
          'Authorization': 'Bearer ' + this.authToken,
          'cache-control': 'no-cache',
          'content-disposition': `attachment; filename=${this.mediaName}`,
          'content-type': theFile.type
        }
      }

      let postData = theFile;
      let mediaURL = '';

      axios.post(wpPostPoint, postData, axiosConfig)
        .then(response => {
          mediaURL = response.data.source_url;
          this.mediaID = response.data.id * 1;
          this.resource.featured_image = this.mediaID;
          console.log('Media ID: ' + this.mediaID);
          console.log('Media URL: ' + mediaURL);
          this.msg2 = 'Upload Complete';
          this.previewFeaturedImage = mediaURL;
          setTimeout(() => {
            this.msg2 = '';
          }, 5000);
        }).catch(function (error) {
          console.log('Error osn post: ' + error);
        });
    },
    getMediaCode(path, mediaMIME) {

      switch (mediaMIME.type) {
        case "image":
          return `
              <div>
                <img src="${path}">
              </div>        
            `;

        case "audio":
          return `
              <div>
                <audio controls src="${path}"></audio>
              </div>    
            `;

        case "video":
          return `
              <div>
                <video controls src="${path}"></video>
              </div>    
            `;

        default:
          return ''; // what to use for this...?
      }
    },
    getCookie(name) {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(';').shift();
    },
    speakersImagesUpload(event, i) {
      this.resource.speakers[i].speaker.speaker_info.image = event.target.files[0];
      this.resource.speakers[i].speaker.speaker_info.msg = 'Uploading...';
      const wpPostPoint = `/wp-json/wp/v2/media`;
      let theFile = this.resource.speakers[i].speaker.speaker_info.image;

      this.mediaName = theFile.name;

      let axiosConfig = {
        headers: {
          'Authorization': 'Bearer ' + this.authToken,
          'cache-control': 'no-cache',
          'content-disposition': `attachment; filename=${this.mediaName}`,
          'content-type': theFile.type
        }
      }

      let postData = theFile;
      let mediaURL = '';

      axios.post(wpPostPoint, postData, axiosConfig)
        .then(response => {
          mediaURL = response.data.source_url;
          this.mediaID = response.data.id * 1;
          this.resource.speakers[i].speaker.speaker_info.image = this.mediaID;
          console.log('Media ID: ' + this.mediaID);
          console.log('Media URL: ' + mediaURL);
          this.resource.speakers[i].speaker.speaker_info.msg = 'Upload Complete';
          setTimeout(() => {
            this.resource.speakers[i].speaker.speaker_info.msg = '';
          }, 5000);
          this.resource.speakers[i].speaker.speaker_info.imagePreview = mediaURL;
        }).catch(function (error) {
          console.log('Error osn post: ' + error);
        });
        
    }
  },
  created() {
    this.getResourseTypes();
  }
};
</script>

<style scoped lang="sass">
  .type--select
    height: 200px !important

  input, select, textarea
    border: 1px solid #555 !important

  .agenda--form
    background: #f9f9f9
    padding: 20px
    margin: 20px 0
    border: 1px dashed #ddd

  .speaker--form, .day--form, .agenda--form
    position: relative

  .item--removal
    position: absolute !important
    right: 0 !important
    top: 0 !important
    z-index: 55 !important
    height: 30px !important
    width: 30px !important
    display: flex !important
    align-items: center !important
    justify-content: center !important
    padding: 0 !important
    margin: 0 !important
    background: #555 !important
    color: white !important
    font-weight: normal !important
    font-size: 15px !important
</style>